import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from './SectionFilters.module.scss';
import {
  ButtonPrimary,
  Checkbox,
  Input,
  Label,
  SelectInput,
} from '@skf/bt-wind-rail-commonlibrary';
import {
  SectionFilter,
  SectionFilterFilterType,
  createEmptySectionFilter,
} from '../../../../store/sections/types';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';

export interface SectionFilterFormProps {
  filterTypes: SectionFilterFilterType[];
  onAddFilter: (newFilter: SectionFilter) => void;
}

export const SectionFiltersForm = ({
  filterTypes,
  onAddFilter,
}: SectionFilterFormProps) => {
  const { t } = useTranslation();

  const [newFilter, setNewFilter] = useState<SectionFilter>(
    createEmptySectionFilter()
  );

  const getFilterTypeOptions = (): IOption[] => {
    return filterTypes.map((x) => {
      return {
        value: x.filterTypeCode,
        label: x.filterTypeDescription,
        labelToShow: x.filterTypeDescription,
      };
    });
  };

  const onAddFilterClick = () => {
    onAddFilter(newFilter);
  };

  const validateNewFilter = (): boolean => {
    if (newFilter.webSectionFilterName.length === 0) return true;
    if (newFilter.webSectionFilterPowerBiTableName.length === 0) return true;
    if (newFilter.webSectionFilterPowerBiFieldName.length === 0) return true;
    if (newFilter.webSectionFilterTypeCode.length === 0) return true;
    if (newFilter.webSectionSnowflakeTableName.length === 0) return true;
    if (newFilter.webSectionSnowflakeColumnName.length === 0) return true;
    return false;
  };

  return (
    <div className={style.sectionFiltersFormContainer}>
      <div className={style.inputSectionFilterContainer}>
        <Label>{t('Section_Filters_SectionName')}</Label>
        <Input
          type="text"
          className={style.inputSectionFilter}
          value={newFilter.webSectionFilterName}
          onChange={(e) =>
            setNewFilter({ ...newFilter, webSectionFilterName: e })
          }
        />
      </div>
      <div className={style.inputSectionFilterContainer}>
        <Label>{t('Section_Filters_PowerBITable')}</Label>
        <Input
          type="text"
          className={style.inputSectionFilter}
          value={newFilter.webSectionFilterPowerBiTableName}
          onChange={(e) =>
            setNewFilter({ ...newFilter, webSectionFilterPowerBiTableName: e })
          }
        />
      </div>
      <div className={style.inputSectionFilterContainer}>
        <Label>{t('Section_Filters_PowerBIField')}</Label>
        <Input
          type="text"
          className={style.inputSectionFilter}
          value={newFilter.webSectionFilterPowerBiFieldName}
          onChange={(e) =>
            setNewFilter({ ...newFilter, webSectionFilterPowerBiFieldName: e })
          }
        />
      </div>
      <div
        className={`${style.inputSectionFilterContainer} ${style.inputSectionFilterTypeDropdown}`}
      >
        <Label>{t('Section_Filters_FilterType')}</Label>
        <SelectInput
          // className={style.inputSectionFilter}
          options={[...getFilterTypeOptions()]}
          value={newFilter.webSectionFilterTypeCode}
          placeHolder={newFilter.webSectionFilterTypeDescription}
          onSelectedItemChanged={(item) => {
            setNewFilter({
              ...newFilter,
              webSectionFilterTypeCode: item?.value.toString() ?? '',
              webSectionFilterTypeDescription: item?.label ?? '',
            });
          }}
        />
      </div>
      <div className={style.inputSectionFilterContainer}>
        <Label>{t('Section_Filters_SnowflakeTable')}</Label>
        <Input
          type="text"
          className={style.inputSectionFilter}
          value={newFilter.webSectionSnowflakeTableName}
          onChange={(e) =>
            setNewFilter({ ...newFilter, webSectionSnowflakeTableName: e })
          }
        />
      </div>
      <div className={style.inputSectionFilterContainer}>
        <Label>{t('Section_Filters_SnowflakeFields')}</Label>
        <Input
          type="text"
          className={style.inputSectionFilter}
          value={newFilter.webSectionSnowflakeColumnName}
          onChange={(e) =>
            setNewFilter({ ...newFilter, webSectionSnowflakeColumnName: e })
          }
        />
      </div>
      <div
        className={`${style.inputSectionFilterContainer} ${style.inputSectionFilterCheckbox}`}
      >
        <Label>{t('Section_Filters_SingleSelect')}</Label>
        <Checkbox
          square={true}
          isChecked={newFilter.webSectionSingleSelectFlag}
          className={style.inputSectionFilter}
          onClick={(e) =>
            setNewFilter({
              ...newFilter,
              webSectionSingleSelectFlag: !newFilter.webSectionSingleSelectFlag,
            })
          }
        />
      </div>
      <div
        className={`${style.inputSectionFilterContainer} ${style.inputSectionFilterCheckbox}`}
      >
        <Label>{t('Section_Filters_Search')}</Label>
        <Checkbox
          square={true}
          isChecked={newFilter.webSectionSearchFlag}
          className={style.inputSectionFilter}
          onClick={(e) =>
            setNewFilter({
              ...newFilter,
              webSectionSearchFlag: !newFilter.webSectionSearchFlag,
            })
          }
        />
      </div>
      <ButtonPrimary disabled={validateNewFilter()} onClick={onAddFilterClick}>
        {t('Section_Filters_Addfilter')}
      </ButtonPrimary>
    </div>
  );
};
